module.exports = __webpack_public_path__ + "img/agenttracker-list.e45d9e3c.png";